export enum DrawerPosition {
  BOTTOM = 'bottom',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum BottomDrawerSize {
  MID = 'mid',
  LARGE = 'large',
}

export type DrawerWidthSize = 'auto' | 'fixed';
